import { useEffect, useState } from 'react';
import useAuthenticatedApi from '../Authentication/components/hooks/useAuthenticatedApi';
import { Card, CardContent, CardHeader, CardTitle } from '@/src/shadComponents/ui/card';

export default function ServerHealthTable() {
    const [diskUsage, setDiskUsage] = useState<string>();
    const [hostname, setHostname] = useState<string>();
    const authenticatedApi = useAuthenticatedApi();

    useEffect(() => {
        let isMounted = true;
        let getData = async () => {
            let results = await authenticatedApi.get(
                '/telemetry/server-resource-usage',
            );

            if (isMounted) {
                setDiskUsage(results.data.diskUsage);
                setHostname(results.data.hostname);
            }
        };
        getData();

        let interval = setInterval(getData, 10000);

        return () => {
            isMounted = false;
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4 lg:px-8">
            <Card>
                <CardHeader>
                    <CardTitle className="text-sm font-medium text-muted-foreground">
                        Hostname
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="text-3xl font-medium leading-10 tracking-tight text-foreground whitespace-nowrap">
                        {hostname}
                    </div>
                </CardContent>
            </Card>
            <Card>
                <CardHeader>
                    <CardTitle className="text-sm font-medium text-muted-foreground">
                        Disk Usage
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="text-3xl font-medium leading-10 tracking-tight text-foreground">
                        {diskUsage}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
